import type { WorkOrderChangePriceItem } from 'gql/graphql';
import { useProjectData } from 'hooks/useProjectData';
import { WorkOrderOrChangeObjectTotals } from 'pages/Project/UerProject/ObjectTotals/WorkOrderOrChangeObjectTotals';
import { Button, IconExpand } from 'uikit';

import * as R from 'ramda';
import type React from 'react';
import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

interface IObjectTotalsButton {
    data?: WorkOrderChangePriceItem;
}

export const ObjectTotalsButton: React.FC<IObjectTotalsButton> = (props) => {
    const { data } = props;

    const { id: projectId } = useParams();
    const { projectData } = useProjectData(projectId, false);

    const [isObjectTotalsOpen, setIsObjectTotalsOpen] = useState<boolean>(false);

    const onSwitchObjectTotalsVisibility = useCallback(() => {
        setIsObjectTotalsOpen(R.not);
    }, []);

    return (
        <>
            <Button iconLeft={IconExpand} onlyIcon view="clear" size="xs" onClick={onSwitchObjectTotalsVisibility} />
            {isObjectTotalsOpen && (
                <WorkOrderOrChangeObjectTotals
                    onClose={onSwitchObjectTotalsVisibility}
                    rowData={data}
                    costRounding={projectData?.contractNavigation?.data?.contractNavData?.metadata?.costRounding ?? 0}
                    isChange
                />
            )}
        </>
    );
};

ObjectTotalsButton.displayName = 'ObjectTotalsButton';
